import { useEffect, memo } from 'react';
import { useInstanceStatus } from "../hooks/useInstanceStatus";
import { useHostStatus } from "../hooks/useHostStatus";

// Constants.
import ReactTooltip from "react-tooltip";

function StatusIcon(props: { instanceId?: number, removeFromList?: Function, hostId?: number, mode?: string }) {
    const { instanceId, removeFromList, hostId } = props;

    // Always call hooks (React requirement), but they handle invalid IDs internally by not polling
    const instanceStatus = useInstanceStatus(instanceId || 0);
    const hostStatus = useHostStatus(hostId || 0);

    useEffect (() => { ReactTooltip.rebuild (); }, []);

    // Handle instance removal from list when instance is no longer available
    useEffect(() => {
        if (instanceId && instanceId > 0 && instanceStatus.status === 404 && removeFromList) {
            // Instance not found - remove from list
            removeFromList(instanceId);
        }
    }, [instanceStatus, instanceId, removeFromList]);

    // Handle host removal from list when host is no longer available
    useEffect(() => {
        if (hostId && hostId > 0 && hostStatus.status === 404 && removeFromList) {
            // Host not found - remove from list
            removeFromList(hostId);
        }
    }, [hostStatus, hostId, removeFromList]);

    // Use the appropriate status based on whether we're showing instance or host
    const status = (instanceId && instanceId > 0) ? instanceStatus : hostStatus;

    let className = 'fas fa-question-circle text-secondary fa-fw';
    let tooltip = 'Health unknown';
    const reason = status.reason ? ` - ${status.reason}` : '';

    if (status.state.toLowerCase() === 'started') {
        if (status.status === 200) {
            className = 'fas fa-shield-check text-success fa-fw';
            tooltip = `Sensor - ${status.state}${reason}`;
        } else {
            className = 'fas fa-question-circle text-danger fa-fw';
            tooltip = `Sensor - ${status.message}`;
        }
    } else {
        tooltip = `Sensor - ${status.state}${reason}`;
    }

    return <i className={className} aria-hidden="true" data-tip={tooltip}></i>;
};

export default memo(StatusIcon);
